module.exports = __webpack_public_path__ + "img/vip-icon.66b8e380.png";